// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-select-docs',
    templateUrl: './select.docs.generated.html',
})
export class UISelectDocs { }
